const downloadLink = (url, fileRename) => {
    // Promise를 반환하여 다운로드가 완료되면 resolve하도록 함
    return new Promise((resolve) => {
        const fileName = fileRename || extractFileNameFromUrl(url);

        const linkElement = document.createElement("area");

        linkElement.download = fileName;
        linkElement.href = url;
        linkElement.style.display = "none";

        document.body.appendChild(linkElement);

        linkElement.click();
        document.body.removeChild(linkElement);

        setTimeout(() => {
            resolve();
        }, 500);
    });
};

const extractFileNameFromUrl = (url) => {
    const split = url.split("?");

    if (split[0]) return split[0].slice(split[0].lastIndexOf("/") + 1);

    return "undefined";
};

export default downloadLink;
